import {EEToolContextMenuItem, IMenuActionFunction, IMenuSinkActionFunction} from "../../types/EEToolContextMenuItem";

export class MenuService {
    static createSplashRemoveMenuItem(description: string, funFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'Remove ' + description + ' Upgrade',
            fun: () => funFunc()
        };
    }

    static createSplashUpgradeMenuItem(description: string, funFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'Upgrade to ' + description,
            fun: () => funFunc()
        };
    }

    static makeMenuCounter(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: 'Rotate Counter Left',
            fun: funcArr[0]
        }, {
            text: 'Rotate Counter Right',
            fun: funcArr[1]
        }, {
            text: 'Duplicate Counter',
            fun: funcArr[2]
        }, {
            text: 'Delete Counter',
            fun: funcArr[3]
        }];
    }

    static makeMenuLineRadius(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: 'Full Radius',
            fun: funcArr[0]
        }, {
            text: 'Bump Out',
            fun: funcArr[1]
        }, {
            text: 'Bump In',
            fun: funcArr[2]
        }];
    }

    static makeRemoveRadiusMenu(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: 'Change Radius',
            fun: funcArr[0]
        }, {
            text: 'Remove Radius',
            fun: funcArr[1]
        }];
    }

    static makeMenuCornerRadius(funcArr: IMenuActionFunction[], haveRemove: boolean, havaLaminate: boolean): EEToolContextMenuItem[] {
        let retVal: EEToolContextMenuItem[] = [{
            text: 'Corner Radius',
            fun: funcArr[0]
        }, {
            text: 'Diagonal',
            fun: funcArr[1]
        }];
        if (havaLaminate) {
            retVal.push({
                text: 'Clipped Corner',
                fun: funcArr[3]
            });
        }
        if (haveRemove) {
            retVal.push({
                text: 'Leave corner square',
                fun: funcArr[2]
            });
        }

        return retVal;
    }

    static makeMenuBacksplash(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: '3" Splash',
            fun: funcArr[0]
        }, {
            text: '4" Splash',
            fun: funcArr[1]
        }, {
            text: 'Other Splash',
            fun: funcArr[2]
        }, {
            text: 'CookTop Splash',
            fun: funcArr[3]
        }];
    }

    static makeMenuCookTopSplashDetail(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: 'Remove',
            fun: funcArr[0]
        }, {
            text: 'Rotate',
            fun: funcArr[1]
        },
            {
                text: 'Resize',
                fun: funcArr[2]
            }
        ];
    }

    static makeMenuSinkDetail(isResizable: boolean, funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        if (!isResizable) {
            return [{
                text: 'Remove',
                fun: funcArr[0]
            }, {
                text: 'Rotate',
                fun: funcArr[1]
            }
            ];
        }
        return [{
            text: 'Remove',
            fun: funcArr[0]
        }, {
            text: 'Rotate',
            fun: funcArr[1]
        }, {
            text: 'Resize',
            fun: funcArr[2]
        }
        ];
    }

    static makeRemoveBumpMenu(logicFunc: IMenuActionFunction): EEToolContextMenuItem[] {
        return [{
            text: 'Remove Bump',
            fun: () => {
                logicFunc();
            }
        }];
    }

    static makeCapRemoveMenuItem(disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'remove cap selection',
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static makeSplashRemoveMenuItem(disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'remove splash selection',
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static makeEdgeRemoveMenuItem(disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'remove edge selection',
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static makeEdgeMenuItem(edgeType: string, disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: edgeType,
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static makeEndCap(disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'End Cap',
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static makeEndSplash(disable: boolean, logicFunc: IMenuActionFunction): EEToolContextMenuItem {
        return {
            text: 'End Splash',
            disabled: disable,
            fun: () => {
                logicFunc();
            }
        };
    }

    static pleaseSelectACounterMenu(): EEToolContextMenuItem[] {
        return [{
            text: 'Please click on a countertop',
            disabled: true,
            fun: () => {
            }
        }
        ];
    }

    static makeMenuSink(sinkIDDescArr: any,
                        funcEmpty: IMenuActionFunction,
                        funcAddSink: IMenuSinkActionFunction,
                        funcAddCookTop: IMenuActionFunction,
                        funcCastIron: IMenuSinkActionFunction,
                        funcNonCastIron: IMenuSinkActionFunction,
                        funcRefrigerator: IMenuActionFunction,
                        funcRange: IMenuActionFunction,
                        funcDishWasher: IMenuActionFunction,
                        funcApron: IMenuSinkActionFunction): EEToolContextMenuItem[] {
        let custSinkSubMenuArr: EEToolContextMenuItem[] = [
            {
                text: 'Single',
                fun: MenuService.makeSinkFunction(0, funcCastIron)
            },
            {
                text: 'Double 50-50',
                fun: MenuService.makeSinkFunction(1, funcCastIron)
            },
            {
                text: 'Double 60-40 L',
                fun: MenuService.makeSinkFunction(2, funcCastIron)
            },
            {
                text: 'Double 70-30 L',
                fun: MenuService.makeSinkFunction(3, funcCastIron)
            },
            {
                text: 'Double 60-40 R',
                fun: MenuService.makeSinkFunction(4, funcCastIron)
            },
            {
                text: 'Double 70-30 R',
                fun: MenuService.makeSinkFunction(5, funcCastIron)
            }
        ];
        let custSinkNonCastIronSubMenuArr: EEToolContextMenuItem[] = [
            {
                text: 'Single',
                fun: MenuService.makeSinkFunction(0, funcNonCastIron)
            },
            {
                text: 'Double 50-50',
                fun: MenuService.makeSinkFunction(1, funcNonCastIron)
            },
            {
                text: 'Double 60-40 L',
                fun: MenuService.makeSinkFunction(2, funcNonCastIron)
            },
            {
                text: 'Double 70-30 L',
                fun: MenuService.makeSinkFunction(3, funcNonCastIron)
            },
            {
                text: 'Double 60-40 R',
                fun: MenuService.makeSinkFunction(4, funcNonCastIron)
            },
            {
                text: 'Double 70-30 R',
                fun: MenuService.makeSinkFunction(5, funcNonCastIron)
            }
        ];
        let custApronFarmSubMenuArr: EEToolContextMenuItem[] = [
            {
                text: 'Single',
                fun: MenuService.makeSinkFunction(0, funcApron)
            },
            {
                text: 'Double 50-50',
                fun: MenuService.makeSinkFunction(1, funcApron)
            },
            {
                text: 'Double 60-40 L',
                fun: MenuService.makeSinkFunction(2, funcApron)
            },
            {
                text: 'Double 70-30 L',
                fun: MenuService.makeSinkFunction(3, funcApron)
            },
            {
                text: 'Double 60-40 R',
                fun: MenuService.makeSinkFunction(4, funcApron)
            },
            {
                text: 'Double 70-30 R',
                fun: MenuService.makeSinkFunction(5, funcApron)
            }
        ];
        let custSinkCastIronSubMenuArr: EEToolContextMenuItem[] = [
            {
                text: 'Cast Iron',
                fun: funcEmpty,
                items: custSinkSubMenuArr
            },
            {
                text: 'Non-Cast Iron',
                fun: funcEmpty,
                items: custSinkNonCastIronSubMenuArr
            },
            {
                text: 'Apron/Farm Sink Cutout',
                fun: funcEmpty,
                items: custApronFarmSubMenuArr
            }
        ];
        //var custSinkOptions =  {
        //                    name: 'Customer Supplied Drop-In Sink',
        //                    title: 'No-Cost Sinks',
        //                    fun: funcArr[0],
        //                    subMenu: custSinkSubMenuArr
        //};
        let custSinkOptions: EEToolContextMenuItem = {
            text: 'Customer Supplied UnderMount Sink',
            fun: funcEmpty,
            items: custSinkCastIronSubMenuArr
        };

        let subMenu: EEToolContextMenuItem[] = [];
        if (sinkIDDescArr && sinkIDDescArr.length > 0) {
            var subCategory: any = {};
            var keys = [];
            var subMenuResult: EEToolContextMenuItem[] = [];
            for (var i = 0; i < sinkIDDescArr.length; i++) {
                if (!sinkIDDescArr[i].Category) {
                    subMenu.push({
                        text: sinkIDDescArr[i].Description,
                        fun: MenuService.makeSinkFunction(sinkIDDescArr[i].Id, funcAddSink)
                    });
                } else {
                    if (!subCategory[sinkIDDescArr[i].Category]) {
                        subCategory[sinkIDDescArr[i].Category] = [];
                        keys.push(sinkIDDescArr[i].Category);
                    }
                    subCategory[sinkIDDescArr[i].Category].push({
                        text: sinkIDDescArr[i].Description,
                        fun: MenuService.makeSinkFunction(sinkIDDescArr[i].Id, funcAddSink)
                    });
                }
            }
            keys.sort();
            for (var key in keys) {
                if (keys.hasOwnProperty(key)) {
                    subMenuResult.push(
                        {
                            text: keys[key],
                            fun: funcEmpty,
                            items: subCategory[keys[key]]
                        });
                }
            }
            subMenu = subMenuResult.concat(subMenu);
        } else {
            subMenu = [{
                text: 'None Available',
                disabled: true,
                fun: () => {
                }
            }];
        }
        //subMenu.push(custSinkOptions);
        return [{
            text: 'Add Sink',
            fun: funcEmpty,
            items: subMenu
        },
            custSinkOptions,
            {
                text: 'Add Cook Top',
                fun: funcAddCookTop
            },
            {
                text: 'Refrigerator',
                fun: funcRefrigerator
            },
            {
                text: 'Range',
                fun: funcRange
            },
            {
                text: 'Dish Washer',
                fun: funcDishWasher
            }];
    }

    static makeSinkFunction(id: any, func: IMenuSinkActionFunction): IMenuActionFunction {
        return () => {
            func(id);
        }
    }

    static getBacksplashNoUpgradesMenu(): EEToolContextMenuItem[] {
        return [{
            text: 'No upgrades available',
            disabled: true,
            fun: () => {
            }
        }];
    }

    static createSplashMenuItems(funcArr: IMenuActionFunction[]): EEToolContextMenuItem[] {
        return [{
            text: 'Remove Splash',
            fun: funcArr[0]
        },
            {
                text: 'Add Electrical Cutout',
                fun: funcArr[1]
            },
            {
                text: 'CookTop Splash',
                fun: funcArr[2]
            }];
    }

    static addUndoMenuItem(menuArr: EEToolContextMenuItem[], undoFunc: IMenuActionFunction, disable: boolean = false): EEToolContextMenuItem[] {
        return menuArr.concat([
            {
                text: 'Undo',
                fun: undoFunc,
                disabled: disable
            }
        ]);
    }

}
